import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Row, Col, Grid } from 'react-flexbox-grid';
import AppBar from 'material-ui/AppBar';
import IconButton from 'material-ui/IconButton';
import NavigationArrowBack from 'material-ui/svg-icons/navigation/arrow-back';
import _ from 'lodash';
import * as projectSelectors from '../../redux/projects/selectors';
import * as fileSelectors from '../../redux/files/selectors';
import { categoriesOriginal, getCategories } from '../../fixtures/categories';
import { getFilesByProjectId, clearProjectFiles, setFilter } from '../../redux/files/actions';
import { getProject } from '../../redux/projects/actions';
import FilterPanel from '../../components/FilterPanel';
import DocumentsList from '../../components/DocumentsList';
import "./Category.css";

const mapStateToProps = (state) => ({
  project: projectSelectors.projectDetails(state),
  projectFiles: fileSelectors.projectFiles(state),
  filter: fileSelectors.getFilter(state)
});
const mapDispatchToProps = {
  getProject,
  getFilesByProjectId,
  clearProjectFiles,
  setFilter
};

const NO_CATEGORY = {
  id: "noCategory",
  title: 'No categories',
  symbol: "NC"
};

class Category extends Component {

    state = {
        barHidden: true,
        selectedFiles: []
    };

  componentDidMount() {
    if (!this.componentHasData(this.props)) {
      this.componentUpdateData(this.props);
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps === this.props) {
      return;
    }

    if (!this.componentHasData(nextProps)) {
      this.componentUpdateData(nextProps);
    }
  }

  componentHasData(prop) {
    const { project, projectFiles } = prop;
    return Object.keys(project).length > 0 && projectFiles !== false;
  }

  componentUpdateData(props) {
    const { project, projectFiles } = props;
    const { projectId } = this.props.match.params;

    if (!Object.keys(project).length) {
      this.props.getProject(projectId);
    }
    if (projectFiles != null && !projectFiles && !Object.keys(projectFiles).length) {
      this.props.getFilesByProjectId(projectId);
    }
  }

  _handleSetFilter = (filter) => {
    this.setState({
      filter
    }, () => {
      this.props.setFilter(filter);
    });
  };

  _handleBackButtonClick = () => {
    // this.props.history.pop();
    this.props.history.goBack()
  };
  
  _renderProjectTitle(project, category) {
    let title = [];
    
    if (project && project.title) {
      title.push(<span key="title" className="title">{project.title}</span>);
      
      if (category && category.title) {
        title.push(<span key="category" className="category">{category.title}</span>);
      }
    }
    
    return title;
  }

  render() {
    const { filter, project, projectFiles } = this.props;
    const { categoryId } = this.props.match.params;

    const category = getCategories()[categoryId] || NO_CATEGORY;


    const files = _.filter(projectFiles, category.id === 'noCategory'
      ? (file) => typeof file.categories === 'undefined'
      : (file) => _.some(file.categories, (id) => String(id) === categoryId)
    );

    return (
      <div className="content-container">
        <AppBar
          title={this._renderProjectTitle(project, category)}
          iconElementLeft={
            <IconButton className="back" onClick={this._handleBackButtonClick}>
              <NavigationArrowBack />
            </IconButton>
          }
          zDepth={0}
          className="project-header"
        />
        <Grid fluid className="overflow-scroll">
          {projectFiles !== null && Object.keys(projectFiles).length > 0 &&
          <Row>
            <Col xs={12}>
              <FilterPanel filter={filter} onChange={this._handleSetFilter} />
            </Col>
            <Col xs={12}>
              <DocumentsList
                filteredFiles={files}
                filter={filter}
              />
            </Col>
          </Row>
          }
        </Grid>
      </div>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Category);
